export const LISTING_SKELETON_ITEM_COUNT = 3
export const HOME_SKELETON_ITEM_COUNT = 3
export const ARCHIVE_SKELETON_ITEM_COUNT = 3
export const NETWORK_SKELETON_ITEM_COUNT = 4
export const CHAT_SKELETON_ITEM_COUNT = 8
export const PROFILE_SKELETON_ITEM_COUNT = 5
